import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/service-detail/page'));
const RealizationsPage = lazy(() => import('../pages/realizations/page'));
const RealizationDetailPage = lazy(() => import('../pages/realization-detail/page'));
const ProcessPage = lazy(() => import('../pages/process/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog-post/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/remonty-gorzow',
    element: <ServicesPage />,
  },
  {
    path: '/wykonczenia-wnetrz-gorzow',
    element: <ServiceDetailPage />,
  },
  {
    path: '/remont-lazienki-gorzow',
    element: <ServiceDetailPage />,
  },
  {
    path: '/malowanie-gorzow',
    element: <ServiceDetailPage />,
  },
  {
    path: '/podlogi-gorzow',
    element: <ServiceDetailPage />,
  },
  {
    path: '/uslugi',
    element: <ServicesPage />,
  },
  {
    path: '/uslugi/:slug',
    element: <ServiceDetailPage />,
  },
  {
    path: '/realizacje',
    element: <RealizationsPage />,
  },
  {
    path: '/realizacje/:id',
    element: <RealizationDetailPage />,
  },
  {
    path: '/jak-pracujemy',
    element: <ProcessPage />,
  },
  {
    path: '/cennik',
    element: <PricingPage />,
  },
  {
    path: '/o-nas',
    element: <AboutPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/kontakt',
    element: <ContactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;